import { render, staticRenderFns } from "./TicketSelectPage.vue?vue&type=template&id=835bbe08&scoped=true&"
import script from "./TicketSelectPage.vue?vue&type=script&lang=ts&"
export * from "./TicketSelectPage.vue?vue&type=script&lang=ts&"
import style0 from "./TicketSelectPage.vue?vue&type=style&index=0&id=835bbe08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835bbe08",
  null
  
)

export default component.exports